import { SxProps, Typography } from "@mui/material";
import { UIStyleConstantClasses, UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { ReactNode } from "react";

export interface UILabelProps {
    variant?:
        | "normal"
        | "title"
        | "page_heading_large"
        | "page_heading"
        | "verySmall"
        | "small"
        | "medium"
        | "large"
        | "section_title"
        | "label"
        | "value"
        | "hint"
        | "error_hint"
        | "body1"
        | "body2"
        | "button"
        | "form_label"
        | "caption"
        | "h1"
        | "h2"
        | "h3"
        | "h4"
        | "h5"
        | "h6"
        | "inherit"
        | "overline"
        | "subtitle1"
        | "subtitle2";
    align?: "center" | "inherit" | "justify" | "left" | "right";
    paragraph?: boolean;
    gutterBottom?: boolean;

    color?: "UIBlue" | "UINormal" | "UIBlack" | "UIWhite" | "UIRed" | string;
    fontWeight?: "bold" | "bolder" | number;
    padding?: string;
    paddingTop?: string;
    paddingBottom?: string;
    paddingLeft?: string;
    paddingRight?: string;
    sx?: SxProps;
    children?: ReactNode;
    noWrap?: boolean;
    onClick?: () => void;
    error?: boolean;
}

export function UILabel(props: UILabelProps) {
    let color: string | undefined = props.color;

    if (!color) {
        if (props.variant === "section_title" || props.variant === "page_heading") {
            color = "UIBlue";
        } else {
            color = "UINormal";
        }
    }

    if (props.color) color = props.color;

    if (props.variant === "error_hint") color = UIStyleConstants.RED_COLOR;

    if (color === "UIBlue") color = UIStyleConstants.BLUE_COLOR;
    if (color === "UINormal") color = UIStyleConstants.GRAY_DARK_COLOR;
    if (color === "UIBlack") color = UIStyleConstants.BLACK_COLOR;
    if (color === "UIWhite") color = UIStyleConstants.WHITE_COLOR;
    if (color === "UIRed") color = UIStyleConstants.RED_COLOR;

    if (props.error) color = UIStyleConstants.RED_COLOR;

    let styleOverrides = {
        padding: props.padding,
        paddingLeft: props.paddingLeft,
        paddingRight: props.paddingRight,
        paddingBottom: props.paddingBottom,
        paddingTop: props.paddingTop,
        color: color,
        fontWeight: props.fontWeight,
    };

    if (props.variant === "hint" || props.variant === "error_hint") {
        styleOverrides.paddingLeft = "16px";
    }

    if (props.variant === "form_label") {
        styleOverrides.paddingBottom = "8px";
    }

    let textStyles = {};

    switch (props.variant) {
        case undefined: {
            textStyles = UIStyleConstantClasses.normalText;
            break;
        }
        case "normal": {
            textStyles = UIStyleConstantClasses.normalText;
            break;
        }
        case "form_label": {
            textStyles = UIStyleConstantClasses.normalText;
            break;
        }
        case "title": {
            textStyles = UIStyleConstantClasses.titleText;
            break;
        }
        case "page_heading_large": {
            textStyles = UIStyleConstantClasses.titleTextLarge;
            break;
        }
        case "page_heading": {
            textStyles = UIStyleConstantClasses.titleText;
            break;
        }
        case "verySmall": {
            textStyles = UIStyleConstantClasses.verySmallText;
            break;
        }
        case "small": {
            textStyles = UIStyleConstantClasses.smallText;
            break;
        }
        case "medium": {
            textStyles = UIStyleConstantClasses.mediumText;
            break;
        }
        case "large": {
            textStyles = UIStyleConstantClasses.largeText;
            break;
        }
        case "section_title": {
            textStyles = UIStyleConstantClasses.titleText;
            break;
        }
        case "label": {
            textStyles = UIStyleConstantClasses.normalText;
            break;
        }
        case "value": {
            textStyles = UIStyleConstantClasses.valueText;
            break;
        }
        case "hint": {
            textStyles = UIStyleConstantClasses.smallText;
            break;
        }
        case "error_hint": {
            textStyles = UIStyleConstantClasses.smallText;
            break;
        }

        case "body1": {
            textStyles = UIStyleConstantClasses.normalText;
            break;
        }
        case "body2": {
            textStyles = UIStyleConstantClasses.normalText;
            break;
        }
        case "button": {
            textStyles = UIStyleConstantClasses.normalText;
            break;
        }
        case "caption": {
            textStyles = UIStyleConstantClasses.smallText;
            break;
        }
        case "h1": {
            textStyles = UIStyleConstantClasses.titleTextLarge;
            break;
        }
        case "h2": {
            textStyles = UIStyleConstantClasses.titleTextLarge;
            break;
        }
        case "h3": {
            textStyles = UIStyleConstantClasses.titleText;
            break;
        }
        case "h4": {
            textStyles = UIStyleConstantClasses.titleText;
            break;
        }
        case "h5": {
            textStyles = UIStyleConstantClasses.titleText;
            break;
        }
        case "h6": {
            textStyles = UIStyleConstantClasses.titleText;
            break;
        }
        case "inherit": {
            textStyles = UIStyleConstantClasses.normalText;
            break;
        }
        case "subtitle1": {
            textStyles = UIStyleConstantClasses.mediumText;
            break;
        }
        case "subtitle2": {
            textStyles = UIStyleConstantClasses.mediumText;
            break;
        }
    }

    return (
        <Typography
            sx={{ ...textStyles, ...styleOverrides, ...props.sx }}
            noWrap={props.noWrap}
            variant={"inherit"}
            onClick={props.onClick}
            align={props.align}
            paragraph={props.paragraph}
            gutterBottom={props.gutterBottom}
        >
            {props.children}
        </Typography>
    );
}
